const ACTIONS = {
    GET_GQL_ELIGIBLITY: 'GET_GQL_ELIGIBLITY',
    GET_GQL_ELIGIBLITY_SUCCESS: 'GET_GQL_ELIGIBLITY_SUCCESS',
    GET_GQL_ELIGIBLITY_ERROR: 'GET_GQL_ELIGIBLITY_ERROR',
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    getGQLEligiblity() {
        return {
            type: ACTIONS.GET_GQL_ELIGIBLITY
        };
    },

    getGQLEligiblitySuccess(eligibilityData) {
        return {
            type: ACTIONS.GET_GQL_ELIGIBLITY_SUCCESS,
            payload: {
                eligibilityData
            }
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.GET_GQL_ELIGIBLITY_ERROR,
            payload: {
                errorKey
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};